interface State {
  user: {
    userInfo: {
      IsAdmin: boolean
      CodePays: number
    }
    userPostError: string
    userPostSuccess: boolean
  }
}

export const postSuccess = (state: State) =>
  state.user && state.user.userPostSuccess
export const postError = (state: State) =>
  state.user && state.user.userPostError
export const userDetail = (state: State) => state.user && state.user.userInfo

export const isAdmin = (state: State) =>
  (state.user && state.user.userInfo && state.user.userInfo.IsAdmin) || false

// Si le code pays utilisateur n'est pas renseigné, on indique France (1)
export const paysId = (state: State) =>
  (state.user && state.user.userInfo && state.user.userInfo.CodePays) || 1
